export default __webpack_public_path__ + "static/media/pushPay-label.28218b29.png";